// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { Route, Routes } from 'react-router-dom';
import Loading from '../components/Loading';
import { useRegistryEntries } from '../hooks/other/useRegistryEntries';
import useAllowListRole from '../hooks/queries/registry/allowList/useAllowListRole';
import useDenyListRole from '../hooks/queries/registry/denyList/useDenyListRole';
import useInstrumentSecurityControlService from '../hooks/queries/registry/onboarding/useInstrumentSecurityControlService';
import { CommonUtilitiesLayout } from '../layout/CommonUtilitiesLayout';
import { AllowListDetailPage } from '../pages/registry/allowList/AllowListDetailPage';
import { DenyListDetailPage } from '../pages/registry/denyList/DenyListDetailPage';

export const Registry: React.FC = () => {
  const allowListRole = useAllowListRole();
  const instrumentSecurityControlService = useInstrumentSecurityControlService();
  const denyListRole = useDenyListRole();
  const entries = useRegistryEntries();
  const isLoading =
    allowListRole.isLoading || denyListRole.isLoading || instrumentSecurityControlService.isLoading;
  if (isLoading) return <Loading />;

  return (
    <CommonUtilitiesLayout entries={entries}>
      <Routes>
        {entries.map((r) => (
          <Route key={r.path} path={r.path} element={r.element} />
        ))}
        <Route path="allow-lists/:name" element={<AllowListDetailPage />} />
        <Route path="deny-lists/:name" element={<DenyListDetailPage />} />
      </Routes>
    </CommonUtilitiesLayout>
  );
};
